import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable, tap } from 'rxjs';

import { GroupeÉtapesÀLaCarte } from '../référentiel-métier-parcours/models/groupe-étapes-à-la-carte.model';
import { GroupeÉtapesService } from '../référentiel-métier-parcours/services/groupe-étapes.service';
import { GroupeÉtapesÀLaCarteStore } from '../référentiel-métier-parcours/store/groupe-étapes-à-la-carte/groupe-étapes-à-la-carte.store';

export const groupeÉtapesResolver: ResolveFn<Observable<GroupeÉtapesÀLaCarte> | undefined> = (route) => {
  const groupeÉtapesService = inject(GroupeÉtapesService);
  const groupeÉtapesStore = inject(GroupeÉtapesÀLaCarteStore);
  const id = route.queryParamMap.get('id');
  const type = route.queryParamMap.get('type');

  if (!id || type !== 'groupe-étapes-à-la-carte') {
    return undefined;
  }

  return groupeÉtapesService.findById(id).pipe(
    tap((groupe) => {
      groupeÉtapesStore.ajouterGroupe({ groupe });
      groupeÉtapesStore.select({ id: groupe.id });
    }),
  );
};
